import ouiBase from '@goldwasserexchange/oui';
import { useAccountPositionsHistoryFieldApiByHisMvtId } from '../api';

export const useAccountPositionsHistoryHisMvtCmtConsult = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountPositionsHistoryFieldApiByHisMvtId({
    hisMvtId,
    field: 'HIS_MVT.CMT_CONSULT',
  });
  return result;
};
